import { TResponse } from '@r1-frontend/do-request/core/types';
import { captureQueryError } from '@r1-frontend/do-request/error';

import contentRequest from '~/src/api/requests/contentRequest';

interface IResponse {
    point_id: number,
    address: string,
    work_time: string,
    point_name: string,
    phone: string,
    longitude: number,
    latitude: number,
    company: {
        type: string,
    } | undefined,
}

export interface IRetailPoint extends IResponse {
    pid: number,
    name: string,
    type: string | undefined,
    hours: string,
}

export type TRetailPointResponse = TResponse<IRetailPoint[], any>;

interface IProps {
    providerId: number,
    companyType?: string[],
}

/**
 * GET-запрос точки продаж
 * /perm/v2/retail-point
 * @param {string=} [domain='perm'] поддомен хоста b2c
 */
export const getRetailPoint = async({ providerId, companyType }: IProps): Promise<TRetailPointResponse> => {
    const url = '/v2/retail-point';
    try {
        const response = await contentRequest.get(url, {
            params: {
                providerId,
                company_type: companyType,
            },
        });
        return {
            isSuccess: true,
            payload: prepareData(response.data),
        };
    } catch (err) {
        return captureQueryError(err);
    }
};

export const prepareData = (points: IResponse[]): IRetailPoint[] => {
    if (!Array.isArray(points)) {
        return points;
    }

    return points.map(point => {
        return {
            ...point,
            pid: point.point_id,
            name: point.point_name,
            type: point.company?.type,
            hours: point.work_time,
        };
    });
};
